module.exports = __webpack_public_path__ + "static/imagem-01-home-fcbf5a7517b78384e54148ebf9b968ea.jpg";